module.exports = __webpack_public_path__ + "img/linkedin.f9ed8326.png";